import React from "react";
import styles from "./faqCard.module.scss";

const FaqCard = (props) => {
  const { question, children, containerAlign } = props;

  return (
    <>
      <ul className={styles.listContainer} style={containerAlign}>
        <li>
          <h2>{question}</h2>
        </li>
        {children}
      </ul>
    </>
  );
};

export default FaqCard;
